import * as Device from "expo-device";

import {
  type DiagnosticItem,
  DiagnosticStatus,
} from "@/schemas/app/diagnostic";
import { getDeviceIdentifier } from "@/hooks/device";

const fetchDeviceInfo = async (): Promise<DiagnosticItem[]> => {
  const totalMemory = Device.totalMemory;
  const [deviceType, { deviceId }] = await Promise.all([
    Device.getDeviceTypeAsync(),
    getDeviceIdentifier(),
  ]);
  return [
    {
      id: "isPhysicalDevice",
      name: "Is Physical Device",
      value: Device.isDevice ? "Yes" : "No",
      status: Device.isDevice ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "deviceId",
      name: "Device Id",
      value: deviceId,
      status: deviceId ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "deviceName",
      name: "Device Name",
      value: Device.deviceName || "Unknown",
      status: Device.deviceName ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "deviceBrand",
      name: "Device Brand",
      value: Device.brand || "Unknown",
      status: Device.brand ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "deviceModel",
      name: "Device Model",
      value: Device.modelName || "Unknown",
      status: Device.modelName ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "osName",
      name: "OS Name",
      value: Device.osName || "Unknown",
      status: Device.osName ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "osVersion",
      name: "OS Version",
      value: Device.osVersion || "Unknown",
      status: Device.osVersion ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "totalMemory",
      name: "Total Memory",
      value: totalMemory
        ? `${(totalMemory / (1024 * 1024 * 1024)).toFixed(2)} GB`
        : "Unknown",
      status: totalMemory ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "architecture",
      name: "Architecture",
      value: Device.supportedCpuArchitectures?.[0] ?? "Unknown",
      status: Device.supportedCpuArchitectures
        ? DiagnosticStatus.OK
        : DiagnosticStatus.ERROR,
    },
    {
      id: "deviceType",
      name: "Device Type",
      value: Device.DeviceType[deviceType] ?? "Unknown",
      status:
        deviceType !== Device.DeviceType.UNKNOWN
          ? DiagnosticStatus.OK
          : DiagnosticStatus.WARNING,
    },
    {
      id: "deviceYearClass",
      name: "Device Year Class",
      value: Device.deviceYearClass?.toString() ?? "Unknown",
      status: Device.deviceYearClass
        ? DiagnosticStatus.OK
        : DiagnosticStatus.WARNING,
    },
  ];
};

export default fetchDeviceInfo;
